export const makeUrl = url => process.env.DOMAIN_NAME + url;
